<div class="appHeader text-light">
  <div class="left" *ngIf="!titleonly">
    <a (click)="goBack()" class="headerButton">
      <ion-icon name="arrow-back"></ion-icon>
    </a>
  </div>
  <div class="pageTitle">
    <ng-content></ng-content>
  </div>
  
  <div class="right" *ngIf="!titleonly">   
    <a class="headerButton" *ngIf="!customright && !refreshIcon">          
      <ion-icon name="refresh-outline" (click)="refreshPage()"></ion-icon>
    </a>
    <a (click)="withdrawAdd()" style="color: #fff;" *ngIf="customright">
      <!-- <ion-icon name="notifications-outline"></ion-icon> -->
      <ion-icon name="add-circle-outline"></ion-icon>
  </a>
  </div>
</div>